import React, { useContext } from "react";
import { StandardButton, MediaContainer } from "..";
import { ActivityMultimedia } from "../../types";
import { ColumnContainer, Column, MultimediaTitleContainer, Container, ButtonContainer } from "./ActivityMultimedia.style";
import { BaseActivityProps } from "../Activity/Activity.component";
import { observer } from "mobx-react";
import { StoreContext } from "../../context";
import Title from "../Title/Title.component";
import { isMobile } from "../../utils";

interface Props extends BaseActivityProps {
  activity: ActivityMultimedia;
}

const ActivityMultimediaComponent: React.FC<Props> = (props) => {
  const { core, store } = useContext(StoreContext);
  const texts = store.interfaceText;
  const onValidate = () => {
    if (props.goNext) props.goNext();
  };
  if (props.activity.tracking?.successCondition === "open") {
    core.setInteractionResult(props.activity.id, "correct");
  }
  return (
    <Container id={`${props.activity.id}-multimedia`} className="multimedia-container">
      {props.activity.title && (
        <MultimediaTitleContainer className="multimedia-title-container">
          <Title level={2}>{props.activity.title}</Title>
        </MultimediaTitleContainer>
      )}
      <ColumnContainer className="multimedia-columns-container" reverse={props.activity.type === "multimedia2"}>
        <Column className="multimedia-richetext-column">
          <div
            id={props.activity.id}
            className={`${props.activity.type} rich-text-container`}
            dangerouslySetInnerHTML={{ __html: props.activity.text }}
          />
          <ButtonContainer>
            {props.goNext && !isMobile() && (
              <StandardButton onClick={onValidate}>
                {props.nextBehaviour === "close" ? texts.close : texts.next}
              </StandardButton>
            )}
          </ButtonContainer>
        </Column>
        <Column className="multimedia-media-column">
          <MediaContainer media={props.activity.media} />
        </Column>
        {props.goNext && isMobile() && (
          <Column className="navigation-column">
            <StandardButton onClick={onValidate}>
              {props.nextBehaviour === "close" ? texts.close : texts.next}
            </StandardButton>
          </Column>
        )}
      </ColumnContainer>
    </Container>
  );
};

export default observer(ActivityMultimediaComponent);
